import { FunctionComponent } from "react";
import { brlFormatter, brlFormatter4Digits, brlFormatter4DigitsDecimals, USDTFormatter, USDTFormatter4digits } from "../../../../utils";


export const ExchangeRate: FunctionComponent<{value:number,price:number, currency:string}> = ({value,price,currency}) => {

    const oppositeCurrency = () => {
        if (currency === 'USDT') return 'BRL';
        if (currency === 'BRL') return 'USDT';
    }

    if (currency === 'BRL') {
        return (
            <>
                ≈ {oppositeCurrency()} {USDTFormatter.format(value / price)}<br />
                <span>( cotação: {price} )</span>
            </>
        )
    }
    
    const total = value * price;
    return (
        <>
            ≈ {oppositeCurrency()} {brlFormatter.format(total)}<br />
            <span>( cotação: {price} )</span>
        </>
    )
}